module.exports = __webpack_public_path__ + "img/first_pro.53df3aaf.png";